import { IAssistCard } from '../../redux/features/assistRequest/assistRequest.props';

/**
 * The fields every assist card log line carries (review B2.4), so one card's
 * lines can be joined to its drive-thru session and store in New Relic.
 */
export const assistCardLogFields = (card: IAssistCard) => ({
  requestId: card.requestId,
  sessionId: card.sessionId,
  restaurantCode: card.restaurantCode,
  ...(card.laneId ? { laneId: card.laneId } : {}),
  assistType: card.type,
  isTR: true,
});
